import { emptyError } from "../../Types/ServicesType/servicesType";
import api from "@services/apiList";
import instance from "@services/services";
const {reportsApi}=api
export const patientListReportService = async (data:any): Promise<any> => {
    try {
        const result=await instance.post(reportsApi.patientlistReportSearch,data)
        return result.data
    } catch (error) {
        return emptyError
    }
}
export const patientListReportpdfService = async (data:any): Promise<any> => {
    try {
        const result=await instance.post(reportsApi.patientlistReportSearchpdf,data)
        return result.data
    } catch (error) {
        return emptyError
    }
}
export const patientListReportexcelService = async (data:any): Promise<any> => {
    try {
        const result=await instance.post(reportsApi.patientlistReportSearchexcel,data)
        return result.data
    } catch (error) {
        return emptyError
    }
}